module.exports = __webpack_public_path__ + "img/alerts.20b47412.svg";